import React, { useContext } from 'react';
import { PostLgReactionsContext } from '../../../context/post-lg-reactions-provider';
import { AdminContext } from '../../../context/admin-context';
import { MemberContext } from '../../../context/member-context';
import Svg from '../icons/svg';

function LgFormAddComment() {
  const [provider] = useContext(PostLgReactionsContext);
  const admin = useContext(AdminContext);
  const member = useContext(MemberContext);

  const handleClickOnInput = (e) => {
    e.preventDefault();
    if (admin.auth.value || member.auth.value) {
      provider.inputRef.current.focus();
    } else {
      provider.setShowLoginRequired(true);
      provider.inputRef.current.blur();
    }
  };

  const handleClickOnSubmit = (e) => {
    if (admin.auth.value === false && member.auth.value === false) {
      e.preventDefault();
      provider.setShowLoginRequired(true);
    }
  };

  return (
    <div>
      <form
        className="d-flex f-row align-items-center f-grow-1 f-shrink-1 p-relative"
        method="post"
        onSubmit={provider.formSubmit}
      >
        {provider.repliesId !== 0 && (
          <div className="replies-cancel color-danger f-row align-items-center c-p" onClick={provider.cancelReplies}>
            <span className="font-size-2 ml-8p">لغو ارسال پاسخ</span>
            <span>
              <Svg name={'multiply'} label={'Cancel replies'} fill={'#ed4956'} width={11} height={11} />
            </span>
          </div>
        )}
        <textarea
          className="input d-flex f-grow-1 plho"
          ref={provider.inputRef}
          placeholder="نظر خود را بنویسید ..."
          disabled={provider.requestSending}
          onClick={handleClickOnInput}
          readOnly={!(admin.auth.value || member.auth.value)}
        />
        <button type="submit" className="submit-blue-btn" disabled={provider.submitDisabled} onClick={handleClickOnSubmit}>
          ارسال
        </button>
      </form>
    </div>
  );
}

export default LgFormAddComment;
